import { render } from "./CollaborationPage.vue?vue&type=template&id=bcda2b00&scoped=true"
import script from "./CollaborationPage.vue?vue&type=script&lang=js"
export * from "./CollaborationPage.vue?vue&type=script&lang=js"

import "./CollaborationPage.vue?vue&type=style&index=0&id=bcda2b00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcda2b00"]])

export default __exports__